import React from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';
import styles from './Dimmer.module.scss';
import { addStyle } from './utils';

export const GreyDimmer = ({
  isVisible, onClick, children, className,
}) => {
  const Dimmer = (
    <div
      tabIndex={-1}
      role="button"
      onClick={onClick}
      className={cn(
        styles.dimmer,
        addStyle(isVisible, styles.dimmerVisible),
        className,
      )}>
      {children}
    </div>
  );
  return ReactDOM.createPortal(Dimmer, document.body);
};
